"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _PrimusPriority = _interopRequireDefault(require("./PrimusPriority"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

const PrimusPriorityWidget = (_ref) => {
  let id = _ref.id,
      disabled = _ref.disabled,
      options = _ref.options,
      _ref$value = _ref.value,
      value = _ref$value === void 0 ? undefined : _ref$value,
      autofocus = _ref.autofocus,
      readonly = _ref.readonly,
      onChange = _ref.onChange,
      props = _objectWithoutPropertiesLoose(_ref, ["id", "disabled", "options", "value", "autofocus", "readonly", "onChange"]);

  const enumOptions = options.enumOptions,
        enumDisabled = options.enumDisabled,
        inline = options.inline,
        help = options.help;
  const label = options.title || props.title || props.label || "bool";
  return _react.default.createElement(_PrimusPriority.default, {
    label: label,
    value: value,
    options: enumOptions,
    helperText: help,
    onChange: onChange
  });
};

var _default = PrimusPriorityWidget;
exports.default = _default;
module.exports = exports.default;